import React from "react";
import { useState } from "react";
import { Button } from "semantic-ui-react";

import { fetchDownload } from "actions/downloads";

import styles from "./download.module.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import cx from "classnames";
import { CSVLink } from "react-csv";
import { useRef } from "react";
import { toast } from "react-toastify";

export default function Download({ id, name, request, url, headers, data }) {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [downloadedPercentage, setDownloadedPercentage] = useState(0);

  const csvLink = useRef(null);

  const downloads = useSelector((state) => _.get(state, "downloads", {}));

  useEffect(() => {
    if (downloading) {
      let totalPages = downloads.pagination.totalPages;
      let currentPage = downloads.pagination.currentPage;
      let nextPage = currentPage + 1;

      if (page !== nextPage && nextPage < totalPages) {
        setPage(nextPage);
        handleDownload(nextPage, 10);
      }

      if (downloads.pagination.currentPage > 0) {
        let totalRecordsCount = downloads.pagination.totalRecordsCount;
        let downloadedRecordsCount = downloads.items.length;

        var percentage = Math.floor(
          (downloadedRecordsCount / totalRecordsCount) * 100
        );

        setDownloadedPercentage(percentage);
      }

      if (nextPage === totalPages) {
        setDownloading(false);

        setTimeout(() => {
          csvLink.current.link.click();
          toast.success(`Successfully downloaded report.`);
        }, 500);
      }

      if (downloads.error) {
        toast.error(`Failed to download report`);
      }
    }
  }, [downloads]);


  const handleDownload = (page, limit) => {
    dispatch(fetchDownload({ id, request, url, page, limit }));
  };

  const getFileName = () => {
    return (name ? name : "Reports.csv") + Date.now() + ".csv";
  };

  const getHeaders = () => {
    return headers && headers.length > 0 ? headers : [];
  };

  const getData = () => {
    return data && data.length > 0 ? data : [];
  };

  return (
    <div className={cx(styles.download)}>
      <Button
        className={cx(styles.btn)}
        onClick={() => {
          setPage(0);
          setDownloadedPercentage(0);
          setDownloading(true);

          setTimeout(() => {
            handleDownload(0, 10);
          }, 200);
        }}
        disabled={downloading}
      >
        {downloading ? `Downloading ${downloadedPercentage}%` : "Download"}
      </Button>

      <CSVLink
        filename={getFileName()}
        headers={getHeaders()}
        data={getData()}
        ref={csvLink}
      />
    </div>
  );
}
